import type { CampaignGame } from '@/services/api/types';
import { MS_IN_DAY } from '@CS/utils/Number';

export default (game: CampaignGame) => {
  if (!game) return 0;
  const start = new Date(new Date(game.startTime ?? 0).toISOString()).getTime();
  const now = new Date(new Date().toISOString()).getTime();
  return Math.ceil((now - start) / MS_IN_DAY / 7);
};
